import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, InputNumber, notification, Select} from 'antd';

import {getSellLimit, updateSellLimit} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import {decodeParams} from "../utils/params";

const Option = Select.Option;
const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class EditSellLimitForm extends Component {
  componentDidMount() {
    const {sellLimitId} = decodeParams(this.props.match.params);
    this.props.getSellLimit({sellLimitId});
  }

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const {sellLimitId} = decodeParams(this.props.match.params);
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.updateSellLimit({...values, sellLimitId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, sellLimit, sellLimitLoading} = this.props;
    const {name, period, value} = sellLimit || {};
    return (
      <Card title="Update Sell Limit" loading={sellLimitLoading}>
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              initialValue: name,
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input autoFocus />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Period"
          >
            {getFieldDecorator('period', {
              initialValue: period,
              rules: []
            })(
              <Select>
                <Option key="" value="">Per Order</Option>
                <Option key="daily" value="daily">Daily</Option>
              </Select>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Limit"
          >
            {getFieldDecorator('value', {
              initialValue: value,
              rules: [{
                required: true,
                message: 'Limit is required'
              }]
            })(
              <InputNumber />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={hasErrors(getFieldsError())}
              >
                Update Sell Limit
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

EditSellLimitForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  dispensaryId: PropTypes.string,
  sellLimit: PropTypes.object,
  sellLimitLoading: PropTypes.bool.isRequired,
  getSellLimit: PropTypes.func.isRequired,
  updateSellLimit: PropTypes.func.isRequired,
};

const EditSellLimitPage = Form.create()(EditSellLimitForm);

const mapStateToProps = state => ({
  dispensaryId: state.dispensary.selectedDispensaryId,
  sellLimit: state.sellLimit.sellLimit,
  sellLimitLoading: state.sellLimit.sellLimitLoading,
});

const mapDispatchToProps = dispatch => ({
  getSellLimit: payload => (dispatch(getSellLimit(payload))),
  updateSellLimit: payload => (dispatch(updateSellLimit(payload))),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditSellLimitPage);



// WEBPACK FOOTER //
// ./src/SellLimit/EditSellLimitPage.js